import axios from "axios";
import Config from "../../config";

const actionEditarChamado = (chamadoId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chamados/${chamadoId}/editar`,
        data
    });
};

export default actionEditarChamado;
